/**
 * App /privacy and /terms: link-out (redirect) to canonical marketing legal
 * pages. No duplicated legal HTML in the dashboard app.
 */
import { useEffect } from 'react';
import { getAppLinks } from '@/config/links';

export function LegalRedirectRoute({ kind }: { kind: 'privacy' | 'terms' }) {
  const href = getAppLinks()[kind];

  useEffect(() => {
    window.location.replace(href);
  }, [href]);

  return (
    <main className="flex min-h-screen items-center justify-center p-6 text-sm text-muted-foreground">
      <p>
        Redirecting to{' '}
        <a className="text-primary underline underline-offset-2" href={href} rel="noopener noreferrer">
          {kind === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
        </a>
        …
      </p>
    </main>
  );
}
